(function () {
  var roots = document.querySelectorAll("[data-product-reviews]");
  if (!roots.length) return;
  roots.forEach(function (root) { initReviewsBlock(root); });

  function initReviewsBlock(root) {
  var shopDomain = (root.dataset.shopDomain || "").trim();
  var token = (root.dataset.judgemeToken || "").trim();
  var productId = (root.dataset.productId || "").trim();
  var allReviewsMode = root.dataset.allReviews === "true";
  var starIcon = root.dataset.starIcon || "";
  var initialCount = parseInt(root.dataset.initialCount, 10) || 2;
  var minRating = parseInt(root.dataset.minRating, 10);
  if (isNaN(minRating) || minRating < 1) minRating = 5;
  if (minRating > 5) minRating = 5;

  var photosWrap = root.querySelector("[data-product-reviews-photos]");
  var photosCountEl = root.querySelector("[data-product-reviews-photos-count]");
  var photosList = root.querySelector("[data-product-reviews-photos-list]");
  var barsWrap = root.querySelector("[data-product-reviews-bars]");
  var listWrap = root.querySelector("[data-product-reviews-list]");
  var moreBtn = root.querySelector("[data-product-reviews-more]");

  var lightbox = document.querySelector("[data-product-lightbox]");
  var lightboxImg = lightbox ? lightbox.querySelector("[data-product-lightbox-img]") : null;
  var lightboxCloseEls = lightbox ? lightbox.querySelectorAll("[data-product-lightbox-close]") : [];

  if (!token || !shopDomain) return;
  if (!allReviewsMode && !productId) return;

  fetchProductReviews()
    .then(function (reviews) {
      if (!reviews || !reviews.length) return;
      // Bars: full distribution of all visible reviews
      renderBars(reviews);
      // List + photos: same filtered set by min star rating
      var listedReviews = reviews.filter(function (r) { return r.rating >= minRating; });
      renderPhotos(listedReviews);
      renderReviews(listedReviews);
    })
    .catch(function (err) {
      console.error("product-reviews: fetch failed", err);
    });

  /* ---------- Fetch strategies ---------- */

  function fetchProductReviews() {
    return tryRestAPI()
      .then(function (reviews) {
        if (reviews && reviews.length) return reviews;
        return tryWidgetAPI();
      })
      .catch(function () {
        return tryWidgetAPI();
      });
  }

  function tryRestAPI() {
    var allReviews = [];

    function fetchPage(page) {
      var url =
        "https://judge.me/api/v1/reviews" +
        "?api_token=" + encodeURIComponent(token) +
        "&shop_domain=" + encodeURIComponent(shopDomain) +
        "&per_page=100&page=" + page;

      return fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error("REST " + res.status);
          return res.json();
        })
        .then(function (data) {
          var reviews = data.reviews || [];

          reviews.forEach(function (r) {
            if (isReviewHidden(r)) return;

            if (!allReviewsMode) {
              var extId = String(
                r.product_external_id || r.external_id || r.product_id || ""
              );
              if (extId !== productId) return;
            }

            var pics = [];
            if (r.pictures && r.pictures.length) {
              r.pictures.forEach(function (p) {
                if (isPictureHidden(p)) return;
                var thumb = (p.urls && (p.urls.compact || p.urls.small || p.urls.original)) || "";
                var full = getMaxUrl(p) || thumb;
                if (thumb) pics.push({ thumb: thumb, full: full });
              });
            }

            allReviews.push({
              body: r.body || "",
              rating: parseInt(r.rating, 10) || 5,
              author: (r.reviewer && r.reviewer.name) || "Customer",
              verified: r.verified === "buyer" || r.verified === true,
              created_at: r.created_at || "",
              pictures: pics,
            });
          });

          if (reviews.length >= 100 && page < 10) {
            return fetchPage(page + 1);
          }
          return allReviews;
        });
    }

    return fetchPage(1);
  }

  function tryWidgetAPI() {
    var widgetType = allReviewsMode ? "all_reviews_page" : "product_review";
    var url =
      "https://judge.me/api/v1/widgets/" + widgetType +
      "?api_token=" + encodeURIComponent(token) +
      "&shop_domain=" + encodeURIComponent(shopDomain) +
      (allReviewsMode ? "" : "&external_id=" + encodeURIComponent(productId)) +
      "&per_page=50&page=1";

    return fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error("Widget " + res.status);
        return res.text();
      })
      .then(function (text) {
        var html = "";
        try {
          var json = JSON.parse(text);
          html = json.widget || json.html || json.body || "";
          if (!html) {
            for (var k in json) {
              if (typeof json[k] === "string" && json[k].length > 100) {
                html = json[k];
                break;
              }
            }
          }
        } catch (e) {
          html = text;
        }
        return parseReviewsFromHtml(html);
      });
  }

  /* ---------- HTML parsing (widget fallback) ---------- */

  function parseReviewsFromHtml(html) {
    if (!html || !html.trim()) return [];
    var temp = document.createElement("div");
    temp.innerHTML = html;
    var results = [];

    var selectors = [
      ".jdgm-rev",
      ".jdgm-carousel-item",
      "[data-review-id]",
      ".jdgm-rev-widg__review",
      ".jdgm-all-reviews__review",
      ".jdgm-all-reviews-page__review",
      ".jdgm-rev-widg__reviews .jdgm-rev",
    ];

    for (var i = 0; i < selectors.length; i++) {
      var items = temp.querySelectorAll(selectors[i]);
      if (!items.length) continue;

      items.forEach(function (item) {
        var cls = item.className || "";
        if (cls.indexOf("jdgm--hidden") !== -1 || cls.indexOf("jdgm-hidden") !== -1) return;
        if (item.hasAttribute("hidden") || item.getAttribute("aria-hidden") === "true") return;
        var style = item.getAttribute("style") || "";
        if (style.indexOf("display:none") !== -1 || style.indexOf("display: none") !== -1) return;

        var body = txtFrom(item, [".jdgm-rev__body", ".jdgm-carousel-item__review-body", ".jdgm-rev__content"]);
        var author = txtFrom(item, [".jdgm-rev__author", ".jdgm-carousel-item__reviewer-name"]) || "Customer";
        var rating = ratingFrom(item);
        var picUrl = imgFrom(item, [".jdgm-rev__pic-img", ".jdgm-rev__pics img", ".jdgm-carousel-item__picture img"]);
        var dateStr = txtFrom(item, [".jdgm-rev__timestamp", ".jdgm-rev__date"]);
        var isVerified = !!item.querySelector(".jdgm-rev__buyer-badge, .jdgm-rev__verified-buyer, .jdgm-verified");

        if (!body && author === "Customer") return;

        results.push({
          body: body,
          rating: rating,
          author: author,
          verified: isVerified,
          created_at: dateStr,
          pictures: picUrl ? [{ thumb: picUrl, full: getMaxUrl({ url: picUrl }) || picUrl }] : [],
        });
      });

      if (results.length) return results;
    }
    return results;
  }

  function txtFrom(container, sels) {
    for (var i = 0; i < sels.length; i++) {
      var el = container.querySelector(sels[i]);
      if (el) { var t = el.textContent.trim(); if (t) return t; }
    }
    return "";
  }

  function ratingFrom(el) {
    var rEl = el.querySelector(".jdgm-rev__rating, .jdgm-carousel-item__review-rating");
    if (rEl) {
      var sc = parseInt(rEl.getAttribute("data-score"), 10);
      if (sc) return sc;
      var on = rEl.querySelectorAll(".jdgm-star.jdgm--on, .jdgm--on");
      if (on.length) return on.length;
    }
    var ds = parseInt(el.getAttribute("data-score"), 10);
    return ds || 5;
  }

  function imgFrom(container, sels) {
    for (var i = 0; i < sels.length; i++) {
      var el = container.querySelector(sels[i]);
      if (el) {
        var s = el.getAttribute("src") || el.getAttribute("data-src") || "";
        if (s && s.indexOf("data:") !== 0) return s;
      }
    }
    return "";
  }

  /* ---------- Rating Bars ---------- */

  function renderBars(reviews) {
    if (!barsWrap) return;
    var dist = [0, 0, 0, 0, 0];
    var maxCount = 0;

    reviews.forEach(function (r) {
      var idx = Math.min(Math.max(r.rating, 1), 5) - 1;
      dist[idx]++;
    });

    for (var i = 0; i < 5; i++) {
      if (dist[i] > maxCount) maxCount = dist[i];
    }

    barsWrap.innerHTML = "";

    for (var s = 5; s >= 1; s--) {
      var count = dist[s - 1];
      var pct = maxCount > 0 ? (count / maxCount) * 100 : 0;

      var bar = mkEl("div", "single-product__customer-bar");

      var starsDiv = mkEl("div", "single-product__customer-bar-stars single-product__customer-stars single-product__customer-stars--bar");
      for (var j = 0; j < s; j++) {
        starsDiv.appendChild(starImg(21));
      }
      bar.appendChild(starsDiv);

      var track = mkEl("div", "single-product__customer-bar-track");
      var fill = mkEl("span", "single-product__customer-bar-fill");
      fill.style.width = pct + "%";
      track.appendChild(fill);
      bar.appendChild(track);

      bar.appendChild(mkEl("span", "single-product__customer-bar-count", String(count)));
      barsWrap.appendChild(bar);
    }
  }

  /* ---------- Photos ---------- */

  function renderPhotos(reviews) {
    // Photos only from the same filtered reviews shown in the list
    var allPics = [];
    reviews.forEach(function (r) {
      if (!r.pictures || !r.pictures.length) return;
      r.pictures.forEach(function (p) {
        if (!p || !p.thumb) return;
        allPics.push(p);
      });
    });

    if (!allPics.length || !photosWrap || !photosList || !photosCountEl) return;

    photosCountEl.textContent = String(allPics.length);
    photosList.innerHTML = "";

    allPics.forEach(function (pic) {
      var li = mkEl("li", "single-product__customer-photos-item");
      var img = document.createElement("img");
      img.src = pic.thumb;
      img.alt = "";
      img.width = 78;
      img.height = 78;
      img.loading = "lazy";
      li.appendChild(img);
      li.addEventListener("click", function () { openLightbox(pic.full || pic.thumb); });
      photosList.appendChild(li);
    });

    photosWrap.classList.add("single-product__customer-photos--visible");
  }

  /* ---------- Reviews ---------- */

  function renderReviews(reviews) {
    if (!listWrap) return;
    listWrap.innerHTML = "";

    reviews.forEach(function (review, idx) {
      if (idx > 0) {
        var divider = document.createElement("hr");
        divider.className = "single-product__customer-review-divider";
        if (idx >= initialCount) divider.classList.add("single-product__customer-review-divider--hidden");
        listWrap.appendChild(divider);
      }

      var article = mkEl("article", "single-product__customer-review");
      if (idx >= initialCount) article.classList.add("single-product__customer-review--hidden");

      var meta = mkEl("div", "single-product__customer-review-meta");
      meta.appendChild(buildReviewStars(review.rating));

      var dateText = review.created_at;
      if (dateText && dateText.indexOf("T") !== -1) {
        dateText = formatDate(dateText);
      }
      meta.appendChild(mkEl("p", "single-product__customer-review-date", dateText));

      if (review.verified) {
        meta.appendChild(mkEl("span", "single-product__customer-review-badge", "Verified"));
      }
      article.appendChild(meta);

      var content = mkEl("div", "single-product__customer-review-content");

      var head = mkEl("div", "single-product__customer-review-head");
      head.appendChild(mkEl("p", "single-product__customer-review-author", review.author));
      if (review.verified) {
        head.appendChild(mkEl("span", "single-product__customer-review-badge single-product__customer-review-badge--inline", "Verified"));
      }
      content.appendChild(head);

      if (review.pictures.length) {
        var imgWrap = mkEl("div", "single-product__customer-review-image");
        var img = document.createElement("img");
        img.src = review.pictures[0].thumb;
        img.alt = "";
        img.width = 78;
        img.height = 78;
        img.loading = "lazy";
        imgWrap.appendChild(img);
        (function (src) {
          imgWrap.addEventListener("click", function () { openLightbox(src); });
        })(review.pictures[0].full || review.pictures[0].thumb);
        content.appendChild(imgWrap);
      }

      content.appendChild(mkEl("p", "single-product__customer-review-text", review.body));
      article.appendChild(content);
      listWrap.appendChild(article);
    });

    if (reviews.length > initialCount && moreBtn) {
      moreBtn.hidden = false;
      moreBtn.addEventListener("click", function () {
        listWrap.querySelectorAll(".single-product__customer-review--hidden").forEach(function (n) {
          n.classList.remove("single-product__customer-review--hidden");
        });
        listWrap.querySelectorAll(".single-product__customer-review-divider--hidden").forEach(function (n) {
          n.classList.remove("single-product__customer-review-divider--hidden");
        });
        moreBtn.hidden = true;
      });
    }
  }

  /* ---------- Lightbox ---------- */

  function openLightbox(src) {
    if (!lightbox || !lightboxImg) return;
    lightboxImg.src = src;
    lightbox.hidden = false;
    document.body.style.overflow = "hidden";
  }

  function closeLightbox() {
    if (!lightbox || !lightboxImg) return;
    lightbox.hidden = true;
    lightboxImg.src = "";
    document.body.style.overflow = "";
  }

  if (lightbox) {
    lightbox.addEventListener("click", function (e) {
      if (e.target === lightboxImg) return;
      closeLightbox();
    });
  }

  if (lightboxCloseEls.length) {
    lightboxCloseEls.forEach(function (el) {
      el.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeLightbox();
      });
    });
  }

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeLightbox();
  });

  /* ---------- Helpers ---------- */

  function isTruthyFlag(value) {
    return value === true || value === 1 || value === "1" || value === "true";
  }

  function isReviewHidden(r) {
    if (!r) return true;
    if (isTruthyFlag(r.hidden)) return true;
    if (r.curated === "spam" || r.curated === "hold") return true;
    return false;
  }

  function isPictureHidden(p) {
    if (!p) return true;
    return isTruthyFlag(p.hidden);
  }

  function buildReviewStars(rating) {
    var wrap = mkEl("div", "single-product__customer-stars single-product__customer-stars--review");
    wrap.setAttribute("aria-label", rating + " out of 5 stars");
    for (var i = 0; i < rating; i++) {
      wrap.appendChild(starImg(21));
    }
    return wrap;
  }

  function starImg(size) {
    var img = document.createElement("img");
    img.src = starIcon;
    img.alt = "";
    img.width = size;
    img.height = size;
    return img;
  }

  function formatDate(iso) {
    if (!iso) return "";
    var d = new Date(iso);
    if (isNaN(d.getTime())) return iso;
    var months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
    return months[d.getMonth()] + " " + d.getDate() + ", " + d.getFullYear();
  }

  function getMaxUrl(pic) {
    if (!pic) return "";
    var raw = pic.image_url
      || (pic.image && pic.image.url)
      || pic.url
      || "";
    var fromUrls = "";
    if (pic.urls) {
      fromUrls = pic.urls.huge || pic.urls.large || pic.urls.original || "";
    }
    var best = raw || fromUrls || "";
    return stripImageParams(best);
  }

  function stripImageParams(url) {
    if (!url) return url;
    return url.split("?")[0];
  }

  function mkEl(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }
  }
})();
